module.exports = __webpack_public_path__ + "img/Medical_banner.3dbec9ae.png";